
// Claude 13 Oct 2026: luxury product page (Factory 54 direction, approved by Michael)
(function () {
    function txt(el) {
        if (!el) return '';
        var c = el.cloneNode(true);
        c.querySelectorAll('.visually-hidden').forEach(function (n) { n.parentNode.removeChild(n); });
        return c.textContent.replace(/\s+/g, ' ').trim();
    }
    // keep the order colour > size > stock > add to cart > pickup even if another app moves blocks
    function order() {
        var pickup = document.querySelector('.product__info store-pickup');
        if (!pickup) return;
        var bb = document.querySelector('product-meta .product-form__buy-buttons') || document.querySelector('.product__info > .product-form__buy-buttons');
        if (bb && bb.nextElementSibling !== pickup) pickup.parentNode.insertBefore(bb, pickup);
        var inv = document.querySelector('.product__info product-inventory.product-form__inventory-wrapper');
        var buy = document.querySelector('.product__info .product-form__buy-buttons');
        if (inv && buy && inv.parentNode !== buy.parentNode) buy.parentNode.insertBefore(inv, buy);
    }
    function atcPrice() {
        var btn = document.getElementById('AddToCart');
        if (!btn) return;
        var p = document.querySelector('.product-meta__price-list-container .price--highlight') || document.querySelector('.product-meta__price-list-container .price');
        var val = txt(p);
        var s = btn.querySelector('.mrs-atc-price');
        if (!s) {
            s = document.createElement('span');
            s.className = 'mrs-atc-price';
            var t = btn.querySelector('.loader-button__text');
            if (t && t.nextSibling) btn.insertBefore(s, t.nextSibling); else btn.appendChild(s);
        }
        if (s.textContent !== val) s.textContent = val;
    }
    function stock() {
        document.querySelectorAll('product-inventory .inventory span:not(.icon)').forEach(function (sp) {
            var m = sp.textContent.match(/Only\s+(\d+)\s+items?\s+left/i);
            if (!m) return;
            var want = m[1] === '1' ? 'Last one in this size' : 'Only ' + m[1] + ' left in this size';
            if (sp.textContent.trim() !== want) sp.textContent = want;
        });
    }
    function reviews() {
        document.querySelectorAll('.yotpo-review-widget').forEach(function (w) {
            if (/^\s*0\s+Reviews?/i.test(w.textContent)) w.classList.add('mrs-no-reviews');
            else w.classList.remove('mrs-no-reviews');
        });
    }
    function accordion() {
        var box = document.querySelector('.product-form-tabs');
        if (!box || box.classList.contains('mrs-acc-done')) return;
        var links = box.querySelectorAll('ul.tab-nav li a');
        if (!links.length) return;
        var names = { 'sizing': 'Size Guide', 'size chart': 'Size Guide' };
        var acc = document.createElement('div');
        acc.className = 'mrs-acc';
        links.forEach(function (a, i) {
            var c = box.querySelector(a.getAttribute('href'));
            if (!c || (!c.textContent.replace(/\s+/g, '') && !c.querySelector('img,iframe,table'))) return;
            var d = document.createElement('details');
            var s = document.createElement('summary');
            var name = a.textContent.trim();
            name = names[name.toLowerCase()] || (name.charAt(0).toUpperCase() + name.slice(1).toLowerCase());
            s.textContent = name;
            var body = document.createElement('div');
            body.className = 'mrs-acc-body';
            var he = (c.textContent.match(/[֐-׿]/g) || []).length, en = (c.textContent.match(/[A-Za-z]/g) || []).length;
            body.setAttribute('dir', he > en ? 'rtl' : 'ltr');
            while (c.firstChild) body.appendChild(c.firstChild);
            d.appendChild(s);
            d.appendChild(body);
            acc.appendChild(d);
        });
        // "About <brand>": the brand story kept in the brand's collection description
        var tpl = document.getElementById('mrs-about');
        if (tpl) {
            var tmp = document.createElement('div');
            tmp.innerHTML = tpl.innerHTML;
            if (tmp.textContent.replace(/\s+/g, '')) {
                var d2 = document.createElement('details');
                var s2 = document.createElement('summary');
                s2.textContent = 'About ' + (tpl.getAttribute('data-brand') || 'the brand');
                var b2 = document.createElement('div');
                b2.className = 'mrs-acc-body';
                var he2 = (tmp.textContent.match(/[֐-׿]/g) || []).length, en2 = (tmp.textContent.match(/[A-Za-z]/g) || []).length;
                b2.setAttribute('dir', he2 > en2 ? 'rtl' : 'ltr');
                while (tmp.firstChild) b2.appendChild(tmp.firstChild);
                d2.appendChild(s2);
                d2.appendChild(b2);
                acc.appendChild(d2);
            }
        }
        box.parentNode.insertBefore(acc, box.nextSibling);
        box.classList.add('mrs-acc-done');
    }
    function head() {
        var t = document.querySelector('product-meta .product-meta__title');
        var media = document.querySelector('.product > .product__media');
        if (!t || !media || document.querySelector('.mrs-lux-head')) return;
        var wrap = document.querySelector('.product-types-wrap');
        // the colour row names the colour, so the page title drops " in <Colour>"
        if (wrap && wrap.style.display !== 'none' && wrap.querySelector('.product-types-head b')) t.textContent = t.textContent.replace(/\s+in\s+[^]+$/, '');
        var v = document.querySelector('product-meta .product-meta__vendor');
        var h = document.createElement('div');
        h.className = 'mrs-lux-head';
        var link = v && v.querySelector('a');
        var b = document.createElement(link ? 'a' : 'div');
        if (link) b.href = link.getAttribute('href');
        b.className = 'mrs-lux-brand';
        b.textContent = txt(v);
        var n = document.createElement('div');
        n.className = 'mrs-lux-title';
        n.textContent = t.textContent.trim();
        h.appendChild(b);
        h.appendChild(n);
        media.parentNode.insertBefore(h, media);
        document.body.classList.add('mrs-lux-on');
    }
    function colourLabel() {
        var wrap = document.querySelector('.product-types-wrap');
        if (!wrap) return;
        var label = wrap.querySelector('.product-types-head .product-form__option-name');
        if (label && !label.querySelector('b')) {
            var t = document.querySelector('.product-meta__title');
            var m = t ? t.textContent.match(/ in (.+)$/) : null;
            if (m) { var bb = document.createElement('b'); bb.textContent = m[1].trim(); label.textContent = 'Colour '; label.appendChild(bb); }
        }
        if (label) label.innerHTML = label.innerHTML.replace(/Colour:\s*/, 'Colour ');
        if (!wrap.querySelector('.product-types-item') && label && label.querySelector('b')) {
            // only one colour: keep the "COLOUR Black" label, hide the empty photo row
            wrap.style.display = '';
            var sl = wrap.querySelector('.product-types-slider');
            if (sl) sl.style.display = 'none';
        }
    }
    function labels() {
        document.querySelectorAll('.product-form__option-info .product-form__option-name').forEach(function (n) {
            var t = n.textContent.replace(/:\s*$/, '');
            if (t !== n.textContent) n.textContent = t;
        });
    }
    // "Wear it with": two pieces from the same line, chosen per product (custom.wear_with)
    function wear() {
        if (document.querySelector('.product__info .mrs-wear')) return;
        var tpl = document.getElementById('mrs-wear');
        var anchor = document.querySelector('.mrs-acc') || document.querySelector('.product-form-tabs') || document.querySelector('.product__info store-pickup');
        if (!tpl || !anchor) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = tpl.innerHTML;
        var w = tmp.querySelector('.mrs-wear');
        if (!w || !w.querySelector('.mrs-wear-card')) return;
        anchor.parentNode.insertBefore(w, anchor.nextSibling);
    }
    // "You may also like": same look as the rest of the page (brand once, name without the brand)
    function recs() {
        // sale label in English: "10% הנחה" -> "10% OFF"
        document.querySelectorAll('.shopify-section--product-recommendations .label').forEach(function (l) {
            var m = l.textContent.match(/(\d+)\s*%/);
            if (m && /הנחה/.test(l.textContent)) { var want = m[1] + '% OFF'; if (l.textContent.trim() !== want) l.textContent = want; l.classList.add('mrs-off'); }
        });
        document.querySelectorAll('.shopify-section--product-recommendations product-item').forEach(function (it) {
            if (it.getAttribute('data-mrs')) return;
            var v = it.querySelector('.product-item-meta__vendor'), t = it.querySelector('.product-item-meta__title');
            if (!v || !t) return;
            var vn = v.textContent.trim(), tt = t.textContent.trim();
            if (vn && tt.toLowerCase().indexOf(vn.toLowerCase()) === 0) t.textContent = tt.slice(vn.length).replace(/^[\s\-|]+/, '');
            it.setAttribute('data-mrs', '1');
        });
    }
    function lux() { labels(); colourLabel(); head(); order(); accordion(); wear(); recs(); atcPrice(); stock(); reviews(); }
    // wait until the product-page script (custom.js) has prepared the colour row and tabs
    var tries = 0;
    (function wait() {
        var wrap = document.querySelector('.product-types-wrap');
        var ready = document.querySelector('.product-meta__title') && (!wrap || wrap.getAttribute('data-fixed'));
        if (ready || ++tries > 40) { lux(); return; }
        setTimeout(wait, 100);
    })();
    var n = 0, iv = setInterval(function () { order(); wear(); atcPrice(); stock(); reviews(); if (++n > 40) clearInterval(iv); }, 500);
    document.addEventListener('variant:changed', function () { setTimeout(function () { atcPrice(); stock(); }, 50); });
    if (window.MutationObserver) {
        var obs = new MutationObserver(function () { atcPrice(); stock(); });
        var start = function () {
            var p = document.querySelector('.product-meta__price-list-container');
            var i = document.querySelector('product-inventory');
            if (p) obs.observe(p, { childList: true, subtree: true, characterData: true });
            if (i) obs.observe(i, { childList: true, subtree: true });
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
    }
    // recommendations arrive after the page loads, so tidy them whenever they appear
    if (window.MutationObserver) {
        var robs = new MutationObserver(function () { recs(); });
        var rstart = function () { var s = document.querySelector('.shopify-section--product-recommendations'); if (s) robs.observe(s, { childList: true, subtree: true }); recs(); };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rstart); else rstart();
    }
})();
